import ccLogo from '../../Images/Logo/fccLogo.png'

const NavLogo = () =>{
    return (
        <section>
            <img className="navLogo" src={ccLogo} alt="logo"></img>
        </section>
    )
}

export default NavLogo